define(['./slide-activation-tracker', 'domReady!'], (slideActivation) => {
    'use strict';
    try {
        const targetEl = document.querySelector(location.hash);
        history.replaceState('', '', location.pathname + location.search);
        if (targetEl) {
            setTimeout(() => targetEl.scrollIntoView({behavior: "smooth"}), 1500);
        }
    } catch (oops) {
        //
    }

    let currentSlide = null;
    return () => {
        if (matchMedia('(hover: hover)').matches) {
            return;
        }
        slideActivation.onActivation(slide => {
            document.querySelector(`#${slide}`) && setTimeout(() => currentSlide = slide, 10);
        });
        const orientationMq = matchMedia('(orientation: landscape)');
        orientationMq.addEventListener('change', () => {
            if (currentSlide) {
                location.hash = `#${currentSlide}`;
            }
            location.reload();
        });
    };
});
